module.exports = "/static/img/ultime_blog.png?decbda840ca33edddf009b438184e846";